import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output, signal } from "@angular/core";

@Component({
  selector: "app-confirm-clean-dialog",
  standalone: true,
  templateUrl: "./confirm-clean-dialog.component.html",
  styleUrl: "./confirm-clean-dialog.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmCleanDialogComponent {
  @Input() title = "Clean form?";
  @Input() message = "All entered values will be removed. This action cannot be undone.";
  @Output() confirmed = new EventEmitter<void>();
  readonly isOpen = signal(false);

  open(): void {
    this.isOpen.set(true);
  }

  cancel(): void {
    this.isOpen.set(false);
  }

  confirm(): void {
    this.isOpen.set(false);
    this.confirmed.emit();
  }

  @HostListener("document:keydown.escape")
  closeOnEscape(): void {
    if (this.isOpen()) {
      this.cancel();
    }
  }
}